export default "__VITE_ASSET__PXkN5Xlm__"